if (!customElements.get("footer-details")) {
  class FooterDetails extends AccordionDetails {
    constructor() {
      super();
    }

    connectedCallback() {
      this.openDefault = this.dataset.openDefault === 'true';

      const mql = window.matchMedia('(max-width: 1199px)');

      this._applyState(mql.matches);

      mql.addEventListener('change', (e) => {
        this._applyState(e.matches);
      });
    }

    _applyState(isMobile) {
      if (isMobile) {
        if (!this.openDefault) this.open = false;
      } else {
        this.open = true;
      }
    }
  }
  customElements.define('footer-details', FooterDetails, { extends: 'details' });
}
